// eslint-disable-next-line default-param-last
export const getLocale = (locale = '', params?: { [key: string]: string | number }) =>
  params
    ? Object.entries(params).reduce(
        (acc, [key, value = '']) => acc?.replaceAll(`{{${key}}}`, value.toString()),
        locale,
      ) ?? locale
    : locale;
